var React = require('react');

function L3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"L3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("polygon",{"points":"42.95 82.23 43.14 61.3 23.63 61.12 23.63 61.12 24.18 0.21 0.73 0 0 81.85 42.95 82.23","fill":"#73c9bd","style":{"mixBlendMode":"multiply"}}))]);
}

L3.defaultProps = {"viewBox":"0 0 43.14 82.23"};

module.exports = L3;

L3.default = L3;
